import React, { useState } from "react";
import { connect } from "react-redux";
import Input from "../../../../../../../../../../../components/Input";
import { validateDomain } from "../../../../../../../../../../../helpers/forms/validators/domainBasicDeployment";

function DomainEditor({
                          onChange,
                          domain,
                          setErrors,
                      }) {

    const [_domain, setDomain] = useState(domain);
    const [valid, setValid] = useState(true);
    const [_message, setMessage] = useState(null);

    const _onChange = (e) => {
        const {value} = e.target;
        const {isValid, message} = validateDomain(value, false);
        setValid(isValid);
        setMessage(message);
        if (setErrors) setErrors(!isValid)
    }

    return (
        <Input
            style={{padding: 0}}
            placeholder='Domain name'
            value={_domain}
            onChange={e => {
                _onChange(e);
                onChange(e.target.value)
                setDomain(e.target.value)
            }}
            isValid={!!domain && !valid ? false : undefined}
            error={_message}
            visualVariables={{
                colorIcon: 'var(--colorAccentBasic)',
                height: '5rem',
                colorBorder: 'transparent',
                colorBackground: 'var(--colorBackgroundBasic)',
            }}
        />
    )
}

const mapStateToProps = state => ({
    bodyBuilder: state.deployment.bodyBuilder,
})

export default connect(mapStateToProps)(DomainEditor)